import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'
import { connectRouter } from 'connected-react-router'
import history from '../history'

import { catchError } from 'rxjs/operators'
// reducers and epics
import { api } from '../Services/Api'
import uiReducer from '../Redux/Ui'
import startupReducer from '../Redux/Startup'
import packagesReducer, { fetchPackagesEpic } from './Packages'
import authReducer from '../../Auth/Redux'
import resourcesReducer, { epics as resourcesEpics } from '../../Resources/Redux'
import configuratorReducer, { epics as configuratorEpics } from '../../Configurator/Redux'
import dataReducer from '../../Data/Redux'
import frecReducer from '../../FRec/Redux'
import chatbotReducer from '../../Chatbot/Redux'

import logger from '../../Common/Utils/Logger'

// root reducer
export const RootReducer = combineReducers({
  router: connectRouter(history),
  api: api.reducer,
  startup: startupReducer,
  ui: uiReducer,
  auth: authReducer,
  packages: packagesReducer,
  ...authReducer,
  ...resourcesReducer,
  ...configuratorReducer,
  ...dataReducer,
  frec: frecReducer,
  chatbot: chatbotReducer,
})

// side effects
export const RootEpic = (action$, store$, dependencies) =>
  combineEpics(
    fetchPackagesEpic,
    ...resourcesEpics,
    ...configuratorEpics,
  )(action$, store$, dependencies).pipe(
    catchError((error, source) => {
      logger.error(error)
      return source
    }),
  )
